(function () {
'use strict';

angular
    .module('surveyCampaignControllers')
    .directive('campaignOwnerCard', directive);

directive.$inject = [];

function directive() {
    return {
        scope: {
            campaign: '=',
            owners: '=',
            owner: '=',
            authenticatedUser: '=',
            readOnly          : '=?'
        },
        restrict: 'AE',
        templateUrl: require('./campaignOwnerCard.tpl.html'),
        controller: ['$scope', 'surveyCampaignService', function ($scope, surveyCampaignService) {

            // Show or hide actions
            $scope.showOrHideActions = function ($event) {
                if ($scope.readOnly) return;
                $scope.displayActions = !$scope.displayActions;
                $event.stopPropagation();
            };

            // Show Remove Action?
            $scope.showRemoveAction = function () {
                return $scope.owners.length > 1;
            };

            // Remove owner
            $scope.removeOwner = function () {
                    return surveyCampaignService
                        .removeCampaignOwner($scope.campaign.SlugObject, $scope.owner.ItemPersonID)
                        .then(function () {
                            var ownerToRemoveIdx = _.findIndex($scope.owners, { ItemPersonID: $scope.owner.ItemPersonID });
                            $scope.owners.splice(ownerToRemoveIdx, 1);
                        });
            };

            //// Remove Respondent
            //$scope.removeRespondent = function (respondent) {
            //    return surveyCampaignService
            //        .removeCampaignRespondent($scope.campaign.SlugObject, respondent.CampaignRespondentID)
            //        .then(function () {
            //            $scope.respondents = _.reject($scope.respondents, { CampaignRespondentID: respondent.CampaignRespondentID });
            //        });
            //};

            // Toggle Selection
            $scope.toggleSelection = function ($event) {
                $event.stopPropagation();
            }
        }],
        link: function (scope, element, attrs) {
            scope.layoutRatio = scope.layoutRatio ? scope.layoutRatio : {
                column: 'col-sm-12'
            };

            // Display or not actions
            scope.displayActions = false;
        }
    };
}
})();